import React from "react";

import Box from "../Box";
import Link from "../Link";
import List from "../List";

import { linkResolver } from "../../../utils/links";
import { ulReset } from "../../../utils/styles";

import { ReactComponent as DownArrow } from "../../../images/icons/down-simple-arrow.svg";

const Item = ({ link, linkProps, sx, ...otherProps }) => {
  // const [isOpen, setOpen] = React.useState(false);

  return (
    <Box
      as="li"
      sx={{
        py: 2,
        "--index": 0,
        transition: (theme) => `opacity ${theme.transitions.normal}`,
        transitionDelay: "calc(200ms + 0.045s * var(--index))",
        opacity: 1,
        ...sx,
      }}
      {...otherProps}
    >
      <Link {...linkProps} variant="caps" />
      {!!link.children.length && (
        <>
          <Box as="span" sx={{ display: "inline-block", ml: 1 }}>
            <DownArrow width={10} />
          </Box>
          <List sx={{ pl: 3, mt: 2 }}>
            {link.children.map((link) => (
              <Box
                as="li"
                key={link.to || link.href}
                sx={{
                  ...ulReset,
                  lineHeight: "heading",
                  py: 1,
                }}
              >
                <Link
                  variant="caps"
                  sx={{ color: "muted" }}
                  {...linkResolver(link)}
                />
              </Box>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default Item;
